import {
  EngagementType,
  NowPlayingAdminConfig,
  NowPlayingAdminData,
} from '@/generated/graphql';
import { StageNowPlayingEngagement } from './stage/stage-view';
import { FanNowPlayingEngagement } from './fan/mobile-view';
import { EngagementDefinition } from '../base/EngagementDefinition';
import { PlayIcon } from '@radix-ui/react-icons';

export const nowPlayingEngagementDefinition: EngagementDefinition<
  NowPlayingAdminConfig,
  NowPlayingAdminData
> = {
  title: 'Now Playing',
  Icon: PlayIcon,
  type: EngagementType.NowPlaying,
  stageComponent: StageNowPlayingEngagement,
  fanComponent: FanNowPlayingEngagement,
  getInitialData: () => ({
    currentSong: null,
  }),
  getInitialConfig: () => ({
    allowComments: true,
    allowedReactions: ['😍', '👏', '🤯', '🔥', '🎶'],
    visualizationType: 'default',
  }),
};
